import React from 'react'
import './Ourvision.css'
import target from './about/target.png'
function Ourvision() {
  return (
    <div className='ourvis'>

<div className='ourvision'>


<div>

<h1>Our vision</h1>
<p>We envision a healthcare ecosystem where people from around the world can quickly find credible and reliable answers to their medical problems along with easy access to the best healthcare experts to guide them towards a healthier, happier and more fulfilling life. We aim to be the first port of call for customers having healthcare related need, doubt, or query.</p>
</div>

<div>

<img src={target} alt="" />
</div>

</div>


    </div>
  )
}

export default Ourvision